import { createRequestActions } from '../utils';
import * as productPhraseTRTypes from './productPhraseTRTypes';

export const listProductPhraseTRForProduct = createRequestActions(productPhraseTRTypes.PRODUCT_PHRASE_TR_LIST_FOR_PRODUCT);
export const saveProductPhraseTR = createRequestActions(productPhraseTRTypes.SAVE_PRODUCT_PHRASE_TR, (data, ProductId, CpsrTypeCode) => ({
  data,
  ProductId,
  CpsrTypeCode,
}));
